import { PublicClientApplication } from "@azure/msal-browser";
import { sessionRepository } from "../services/sessionRepository";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../store/loginSlice";
import { toast } from "../store/toastSlice";
import { AlertType } from "../shared/constants/enums";
import { useEffect } from "react";

const Logout = ({
  MSALInstance,
}: {
  MSALInstance: PublicClientApplication;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("Logout component rendered", MSALInstance.getAllAccounts());
  useEffect(() => {
    dispatch(logout());
    dispatch({ type: "RESET" });
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }, []);

  return (
    <div>
      <p>Logging you out.</p>
      <p>Please wait....</p>
    </div>
  );
};

export default Logout;
